<script>
  import { format } from 'svelte-i18n';

  import { getNotificationsContext } from '@client/components/notifications';

  import { GroupsService } from '@client/services/groups';
  import { SignaturesService } from '@client/services/signatures';

  import { GeneralDeleteForm } from '../index.js';

  export let nextDisabled = true;
  export let onExecute = null;
  export let onRollback = null;
  export let step = { data: {} };

  const { addNotification } = getNotificationsContext();

  const notify = (text, type = 'success', autohide = 2500, position = 'top-right') => {
    addNotification({ text, type, autohide, position });
  };

  const getDeletableGroups = async () => {
    const allGroups = await GroupsService.getAll();
    const allSignatures = await SignaturesService.getAll();

    const deletableGroups = allGroups.filter((group) => {
      const filter = allSignatures.filter(
        ({ sendergroups }) => sendergroups && sendergroups.some((sg) => sg.groupname === group.groupname)
      );

      if (filter.length) {
        const primary = filter.find(({ blockname, status }) => blockname && status) || filter.shift();
        return !primary.status;
      }

      return true;
    });

    return deletableGroups.map((group) => ({
      label: group.groupname,
      value: group.groupname,
      ...group
    }));
  };

  const onDeleteGroup = async (group) => {
    const response = await GroupsService.deleteGroup(group);

    if (response !== 'Empty' && response?.status >= 400) {
      notify($format('label.FAILURE.GROUP_DELETE', { values: { group: group.groupname } }), 'error');
      throw new Error($format('label.FAILURE.GROUP_DELETE'));
    }

    notify($format('label.SUCCESS.DELETE', { values: { type: group.groupname } }));

    step.data = {
      id: group.groupname,
      rollbackData: {
        group
      }
    };
  };

  const rollbackDeleteGroup = async () => {
    if (!step.data?.rollbackData) {
      throw new Error($format('label.NO_ROLLBACK_DATA'));
    }

    const { group } = step.data.rollbackData;

    // Restore the group
    const response = await GroupsService.createGroup(group);

    if (response?.status >= 400) {
      notify($format('label.FAILURE.CREATE_GROUP', { values: { item: group.groupname } }), 'error');
      throw new Error($format('label.FAILURE.CREATE_GROUP'));
    }

    notify($format('label.SUCCESS.ROLLBACK_GROUP_DELETE'));

    return { success: true };
  };
</script>

<GeneralDeleteForm
  bind:nextDisabled
  bind:step
  {onExecute}
  {onRollback}
  rollbackFunction={rollbackDeleteGroup}
  getFunction={getDeletableGroups}
  deleteFunction={onDeleteGroup}
  showPreview={false}
/>
